import React, {
  cloneElement,
  type HTMLAttributes,
  type ReactElement,
} from "react";
import { clsx } from "clsx";

export type CircleIconTone =
  | "indigo"
  | "yellow"
  | "lime"
  | "orange"
  | "emerald"
  | "violet"
  | "green";

const COLOR_CLASSES: Record<CircleIconTone, { ring: string; bg: string }> = {
  indigo: {
    ring: "text-indigo-600 border-indigo-600",
    bg: "bg-indigo-50 dark:bg-indigo-950",
  },
  yellow: {
    ring: "text-yellow-600 border-yellow-600",
    bg: "bg-yellow-50 dark:bg-yellow-950",
  },
  lime: {
    ring: "text-lime-600 border-lime-600",
    bg: "bg-lime-50 dark:bg-lime-950",
  },
  orange: {
    ring: "text-orange-600 border-orange-600",
    bg: "bg-orange-50 dark:bg-orange-950",
  },
  emerald: {
    ring: "text-emerald-600 border-emerald-600",
    bg: "bg-emerald-50 dark:bg-emerald-950",
  },
  violet: {
    ring: "text-violet-600 border-violet-600",
    bg: "bg-violet-50 dark:bg-violet-950",
  },
  green: {
    ring: "text-green-600 border-green-600",
    bg: "bg-green-50 dark:bg-green-950",
  },
};

interface Props extends HTMLAttributes<HTMLSpanElement> {
  color: CircleIconTone;
  children: ReactElement<{ size?: number; className?: string }>;
}

export const CircleIcon = ({ color, children, className, ...rest }: Props) => {
  const mergedIcon = cloneElement(children, {
    size: children.props.size ?? 16,
    className: clsx(children.props.className),
  });

  const { ring, bg } = COLOR_CLASSES[color];

  return (
    <span
      className={clsx(
        "flex size-6 items-center justify-center rounded-full border-1",
        ring,
        bg,
        className,
      )}
      {...rest}
    >
      {mergedIcon}
    </span>
  );
};
